import { Box, Tooltip } from '@/ui/primitives';
import { Button } from '@/ui/primitives/Button';
import { UploadFileIcon } from '@/ui/primitives/icons';
import type { ReactElement } from 'react';

type TestingUploadResultsActionProps = {
  disabledReason?: string | null;
  onClick: () => void;
};

const uploadResultsFilesButtonSx = { height: '34px', minHeight: '34px' };

export const TestingUploadResultsAction = ({
  disabledReason = null,
  onClick,
}: TestingUploadResultsActionProps): ReactElement => (
  <Tooltip title={disabledReason ?? ''} disableHoverListener={disabledReason === null}>
    <Box component="span">
      <Button
        startIcon={<UploadFileIcon />}
        fullWidthOnMobile={false}
        disabled={disabledReason !== null}
        onClick={onClick}
        sx={uploadResultsFilesButtonSx}
      >
        Upload Results Files
      </Button>
    </Box>
  </Tooltip>
);
